module.exports = __webpack_public_path__ + "static/media/step1.1e1ba145.jpg";